import { VersionableId } from '../../../../types/versionableId';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { getFormValues } from 'redux-form';
import { SMSC_FORM_NAME } from '../../../../store/form/formStateModel';
import { SmscDataForm } from '../../components/smsc/SmscForm';
import SmscApi from '../../../../api/smscApi';
import ConfigFileViewer from '../../../../shared/components/ConfigFileViewer';
import { AppErrorList, useAppErrorList } from '../../../../shared/components/AppErrorList';

type Props = {
  readonly smscId?: VersionableId;
  readonly readOnly: boolean;
}

const SmscConfigFilePreviewContainer = (props: Props) => {
  const { smscId, readOnly } = props;

  const [isLoading, setLoading] = useState<boolean>(false);
  const [configFile, setConfigFile] = useState<string | undefined>();

  const [{ errors, hasErrors }, { addError, removeError }] = useAppErrorList();
  const smscDataForm = useSelector((state: RootState) => getFormValues(SMSC_FORM_NAME)(state)) as SmscDataForm;

  useEffect(() => {
    if (smscId) {
      setLoading(true);

      SmscApi.fetchSmscConfigFile(smscId)
        .then(setConfigFile)
        .catch(addError)
        .finally(() => setLoading(false));
    }
  }, [addError, smscId]);

  useEffect(() => {
    if (!readOnly) {
      setLoading(true);

      SmscApi.generateSmscConfigFilePreview(smscDataForm)
        .then(setConfigFile)
        .catch(addError)
        .finally(() => setLoading(false));
    }
  }, [addError, readOnly, smscDataForm])

  return (
    <>
      { hasErrors ? (
        <AppErrorList
          errors={errors}
          onCloseError={removeError}
        />
      ) : (
        <ConfigFileViewer
          isGenerating={isLoading}
          content={configFile}
        />
      )}
    </>
  );
};

export default SmscConfigFilePreviewContainer;
